import React from 'react';
import { cn } from '../../lib/utils';

const Button = React.forwardRef(
  ({ className, variant = 'primary', size = 'default', fullWidth = false, loading = false, icon, children, ...props }, ref) => {
    
    const variantClasses = {
      primary: 'btn-primary',
      secondary: 'btn-secondary',
      danger: 'btn-danger',
      ghost: 'btn-ghost',
      outline: 'btn-outline',
      success: 'bg-green-600 text-white hover:bg-green-700',
      red: 'bg-red-50 text-red-600 border border-red-200 hover:bg-red-100'
    };

    const sizeClasses = {
      small: 'py-2 px-3 text-xs rounded-md',
      default: 'py-2.5 px-5 text-sm rounded-lg',
      large: 'px-6 py-3 text-base rounded-lg'
    };
    
    let resolvedVariant = variant;
    if (['blue', 'default'].includes(variant)) resolvedVariant = 'primary';
    if (['purple', 'warning'].includes(variant)) resolvedVariant = 'secondary';

    const resolvedSize = ['sm', 'small'].includes(size) ? 'small' : ['lg', 'large'].includes(size) ? 'large' : 'default';

    return (
      <button
        ref={ref}
        className={cn(
          'btn-base',
          variantClasses[resolvedVariant] || variantClasses.primary,
          sizeClasses[resolvedSize],
          fullWidth ? 'w-full' : '',
          className
        )}
        disabled={props.disabled || loading}
        {...props}
      >
        {loading ? (
          <svg className="mr-2 h-4 w-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <>
            {icon && (
              <span className="mr-2 flex items-center">
                {typeof icon === 'string' ? <img src={icon} alt="" className="w-4 h-4" /> : icon}
              </span>
            )}
          </>
        )}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export { Button };